import React from 'react';
import { Tooltip } from '@components/moleculs/tooltip';
import { useResponsiveTooltip } from '@hooks/use-responsive-tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';

export const ResponsiveTooltip: React.FC<TooltipProps> = ({ onClick, ...props }) => {
    const { isOpen, toggleTooltip, isMdOrTouch } = useResponsiveTooltip();

    const handleClick: TooltipProps['onClick'] = (event) => {
        toggleTooltip();
        onClick?.(event);
    };

    return (
        <Tooltip
            arrow={true}
            open={isMdOrTouch ? isOpen : undefined}
            onClick={handleClick}
            {...props}
        />
    );
};
